import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import Message from "../../ui/components/Messages/Message";

import { useKnownUser } from "../../authentication/state/knownUser";

export default function Account() {
	const { t } = useTranslation();
	const knownUser = useKnownUser();

	return (
		<>
			{!knownUser && (
				<Message info>
					{t(
						"accountWaitingForActivation",
						"Your account is waiting to be activated. You'll get access once an administrator has activated it.",
					)}
				</Message>
			)}

			<Outlet />
		</>
	);
}
